import useOpenTask from "./useOpenTask";
import useIsInappWebview from "./useIsInappWebview";
import useGetDeviceInfo from "./useGetDeviceInfo";
import { compareVersions } from "../logic/logics_common";
import { sendMessage } from "../utils/webview";

export default function useOpenPlanUpgrade() {
  const openPlanUpgrade = useOpenTask({ taskKey: `plan-upgrade` });

  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  return () => {
    if (isInappWebview && compareVersions(appVersion, "1.1.44") >= 0) {
      sendMessage(
        JSON.stringify({
          event: "open_screen",
          params: {
            url: `${window.location.origin}/plan-upgrade`,
            type: "card",
            gestureEnabled: true,
            animation: "default",
            replace: false,
          },
        })
      );
      return;
    }

    if (isInappWebview) {
      sendMessage(
        JSON.stringify({
          event: "open_modal",
          params: {
            url: `${window.location.origin}/plan-upgrade`,
            type: "transparentModal",
          },
        })
      );
    } else {
      openPlanUpgrade();
    }
  };
}
